export default __webpack_public_path__ + "media/images/close-3955c554ca8e759a8d3c6b1cfaad3d7e.svg";